/**
 * Extra algolia tracking to track shopify events.
 * @info - https://www.algolia.com/doc/guides/sending-events/concepts/event-types/#minimum-number-of-events
 */

import aa from "search-insights";

(function(algolia) {

  class AA {

    constructor() {
      if (!aa) {
        return;
      }

      // Initialize the aa instance
      this.aa = aa;

      // Create a random user token
      this.userToken = algolia.config.user_token || this.createRandomUserToken();

      // Initialize the aa instance
      this.aa("init", {
        appId: algolia.config.app_id,
        apiKey: algolia.config.search_api_key,
        userToken: this.userToken,
        useCookie: true,
      });

      // Set the flags
      this.enabled = algolia.config.analytics_enabled;
      this.index = `${algolia.config.index_prefix}products`;
      this.lastClickedVariantId = null;
      this.options = {
        send: true,
        log: true
      }

      /**
       * Shopify.loadFeatures
       * @description Load the Shopify Customer Privacy JavaScript library. With callback.
       */
      Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        (error) => {
          if (error) throw error;

          // Track viewed product
          if (document.querySelector('product-form [name="id"]')) {
            const variantId = document.querySelector('product-form [name="id"]').value
            this.viewedProduct(variantId);
          }
        }
      );
    }

    /**
     * Create a random user token
     * @returns {string}
     */
    createRandomUserToken() {
      return Array.from(Array(20), () =>
        Math.floor(Math.random() * 36).toString(36),
      ).join("");
    }

    /**
     * Check if the user has analytics consent
     * @returns {boolean}
     */
    hasAnalyticsConsent() {
      if (!window.Shopify || !window.Shopify.customerPrivacy) {
        return false;
      }
      const consentStatus = window.Shopify.customerPrivacy.currentVisitorConsent();
      return consentStatus && consentStatus.analytics == 'yes';
    }

    /**
     * Clicked on product event tracking
     * @param {string/int} variantId
     * @returns void
     */
    viewedProduct(variantId = null) {
      if (!this.enabled || !this.userToken || !this.index || !variantId || !this.hasAnalyticsConsent()) {
        return;
      }
      var data = {
        userToken: this.userToken,
        index: this.index,
        eventName: 'Viewed product',
        objectIDs: [String(variantId)]
      };
      if (this.options.send) {
        this.aa("viewedObjectIDs", data);
      }
      if (this.options.log) {
        console.log('Viewed product', data);
      }
    }

    /**
     * Clicked on product event tracking
     * @param {string/int} variantId
     * @returns void
     */
    clickedOnProduct(variantId = null) {
      if (!this.enabled || !this.userToken || !this.index || !variantId || !this.hasAnalyticsConsent()) {
        return;
      }
      var data = {
        userToken: this.userToken,
        index: this.index,
        eventName: 'Clicked on product',
        objectIDs: [String(variantId)]
      };
      if (this.options.send) {
        this.aa("clickedObjectIDs", data);
      }
      if (this.options.log) {
        console.log('Clicked on product', data);
      }
    }

    /**
     * Added to cart product event tracking
     * @param {string/int} variantId
     * @returns void
     */
    addedToCart(variantId = null) {
      if (!this.enabled || !this.userToken || !this.index || !variantId || !this.hasAnalyticsConsent()) {
        return void(0);
      }
      const data = {
        userToken: this.userToken,
        index: this.index,
        eventName: 'Added to cart',
        objectIDs: [String(variantId)]
      };
      if (this.options.send) {
        this.aa("convertedObjectIDs", data);
      }
      if (this.options.log) {
        console.log('Added to cart', data);
      }
    }

    /**
     * Add to cart event tracking
     * @param {array} - variantIds
     * @returns void
     * @info - variantIds can be a maximum of 20 because of the limit of Algolia Api
     */
    cartUpdate(variantIds) {
      if (!this.enabled || !this.userToken || !this.index || !variantIds || !variantIds.length || !this.hasAnalyticsConsent()) {
        return void(0);
      }
      variantIds = variantIds.slice(0, 20);
      variantIds = variantIds.map(String);
      var data = {
        userToken: this.userToken,
        index: 'fg_products',
        eventName: 'Updated the cart',
        objectIDs: variantIds
      };
      if (this.options.send) {
        this.aa("convertedObjectIDs", data);
      }
      if (this.options.log) {
        console.log('Updated the cart', data);
      }
    }


  }

  window.AA = new AA();


})(window.algoliaShopify);



/**
 * Get all fetch requests to track cart changes
 */
(function(ns, fetch) {
  if (typeof fetch !== 'function') {
    return;
  }
  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    if (!AA) {
      return response;
    }
    response.then(async res => {
      if (res.url.includes(routes.cart_change_url) || res.url.includes(routes.cart_update_url) ) {
        const data = await res.clone().json();
        if (!data || !data.items || !data.items.length) {
          return;
        }
        const variantIds = data.items.map(item => item.variant_id);
        AA.cartUpdate(variantIds);
      } else if (res.url.includes(routes.cart_add_url)) {
        const data = await res.clone().json();
        if (!data || !data.variant_id) {
          return;
        }
        AA.addedToCart(data.variant_id);
      }
    });
    return response;
  }
}(window, window.fetch));
